// src/common.ts
var Status = /* @__PURE__ */ ((Status2) => {
  Status2["ACTIVE"] = "active";
  Status2["INACTIVE"] = "inactive";
  Status2["PENDING"] = "pending";
  Status2["ARCHIVED"] = "archived";
  return Status2;
})(Status || {});

// src/user.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["ADMIN"] = "ADMIN";
  UserRole2["BILLING_ADMIN"] = "BILLING_ADMIN";
  UserRole2["BILLING_STANDARD"] = "BILLING_STANDARD";
  UserRole2["ASSOCIATE"] = "ASSOCIATE";
  UserRole2["PARTNER"] = "PARTNER";
  UserRole2["ASSISTANT"] = "ASSISTANT";
  UserRole2["CLERK"] = "CLERK";
  UserRole2["SUPERVISOR"] = "SUPERVISOR";
  UserRole2["BOOKKEEPER"] = "BOOKKEEPER";
  UserRole2["ACCOUNTING_ADMIN"] = "ACCOUNTING_ADMIN";
  UserRole2["HR_STANDARD"] = "HR_STANDARD";
  UserRole2["HR_ADMIN"] = "HR_ADMIN";
  return UserRole2;
})(UserRole || {});
var UserStatus = /* @__PURE__ */ ((UserStatus2) => {
  UserStatus2["ACTIVE"] = "Active";
  UserStatus2["INACTIVE"] = "Inactive";
  return UserStatus2;
})(UserStatus || {});

// src/invoice.ts
var InvoiceStatus = /* @__PURE__ */ ((InvoiceStatus2) => {
  InvoiceStatus2["DRAFT"] = "draft";
  InvoiceStatus2["PENDING"] = "pending";
  InvoiceStatus2["SENT"] = "sent";
  InvoiceStatus2["PAID"] = "paid";
  InvoiceStatus2["OVERDUE"] = "overdue";
  InvoiceStatus2["CANCELLED"] = "cancelled";
  return InvoiceStatus2;
})(InvoiceStatus || {});

// src/auth.ts
var LoginProvider = /* @__PURE__ */ ((LoginProvider2) => {
  LoginProvider2["GOOGLE"] = "Google";
  LoginProvider2["MICROSOFT"] = "Microsoft";
  LoginProvider2["AzureAD"] = "AzureAD";
  LoginProvider2["Clio"] = "Clio";
  return LoginProvider2;
})(LoginProvider || {});

// src/reports.ts
var ArExceptionFlag = /* @__PURE__ */ ((ArExceptionFlag2) => {
  ArExceptionFlag2["OK"] = "OK";
  ArExceptionFlag2["VARIANCE_NON_ZERO"] = "VARIANCE_NON_ZERO";
  ArExceptionFlag2["MISSING_IN_QBO"] = "MISSING_IN_QBO";
  ArExceptionFlag2["MISSING_IN_CLIO"] = "MISSING_IN_CLIO";
  ArExceptionFlag2["DUPLICATE"] = "DUPLICATE";
  ArExceptionFlag2["LOW_CONFIDENCE_MATCH"] = "LOW_CONFIDENCE_MATCH";
  return ArExceptionFlag2;
})(ArExceptionFlag || {});
var TrustReconciliationFlag = /* @__PURE__ */ ((TrustReconciliationFlag2) => {
  TrustReconciliationFlag2["OK"] = "OK";
  TrustReconciliationFlag2["MISSING_IN_QBO_BANK"] = "MISSING_IN_QBO_BANK";
  TrustReconciliationFlag2["MISSING_IN_QBO_LIABILITY"] = "MISSING_IN_QBO_LIABILITY";
  TrustReconciliationFlag2["MISSING_IN_BOTH_QBO"] = "MISSING_IN_BOTH_QBO";
  TrustReconciliationFlag2["MISSING_IN_CLIO"] = "MISSING_IN_CLIO";
  TrustReconciliationFlag2["DUPLICATE"] = "DUPLICATE";
  return TrustReconciliationFlag2;
})(TrustReconciliationFlag || {});
var ConfidenceLevel = /* @__PURE__ */ ((ConfidenceLevel2) => {
  ConfidenceLevel2["HIGH"] = "HIGH";
  ConfidenceLevel2["LOW"] = "LOW";
  return ConfidenceLevel2;
})(ConfidenceLevel || {});
var ReconciliationStatus = /* @__PURE__ */ ((ReconciliationStatus2) => {
  ReconciliationStatus2["MATCHED"] = "matched";
  ReconciliationStatus2["PARTIAL"] = "partial";
  ReconciliationStatus2["MISSING"] = "missing";
  return ReconciliationStatus2;
})(ReconciliationStatus || {});
var MatterTransactionType = /* @__PURE__ */ ((MatterTransactionType2) => {
  MatterTransactionType2["BILL"] = "bill";
  MatterTransactionType2["PAYMENT"] = "payment";
  MatterTransactionType2["TRUST_DEPOSIT"] = "trust_deposit";
  MatterTransactionType2["TRUST_WITHDRAWAL"] = "trust_withdrawal";
  MatterTransactionType2["TRUST_TRANSFER"] = "trust_transfer";
  MatterTransactionType2["ADJUSTMENT"] = "adjustment";
  return MatterTransactionType2;
})(MatterTransactionType || {});
var MatterReportType = /* @__PURE__ */ ((MatterReportType2) => {
  MatterReportType2["LEDGER"] = "ledger";
  MatterReportType2["STATEMENT"] = "statement";
  return MatterReportType2;
})(MatterReportType || {});
var DocumentCategory = /* @__PURE__ */ ((DocumentCategory2) => {
  DocumentCategory2["APPEALS_SUPPORT"] = "Appeals Support";
  DocumentCategory2["PAYMENT_SUPPORT"] = "Payment Support";
  DocumentCategory2["EMAIL_QUEUE"] = "Email Queue";
  return DocumentCategory2;
})(DocumentCategory || {});

// src/ar-collection.ts
var GroupByOption = /* @__PURE__ */ ((GroupByOption2) => {
  GroupByOption2["NONE"] = "none";
  GroupByOption2["CLIENT"] = "client";
  GroupByOption2["ORIGINATING"] = "originating";
  GroupByOption2["RESPONSIBLE"] = "responsible";
  return GroupByOption2;
})(GroupByOption || {});
var ExportType = /* @__PURE__ */ ((ExportType2) => {
  ExportType2["TABLE"] = "table";
  ExportType2["INVOICE_DETAILS"] = "invoice_details";
  ExportType2["TABLE_PDF"] = "table_pdf";
  ExportType2["INVOICE_DETAILS_PDF"] = "invoice_details_pdf";
  return ExportType2;
})(ExportType || {});
var CollectionSortByOption = /* @__PURE__ */ ((CollectionSortByOption2) => {
  CollectionSortByOption2["DAYS_PAST_DUE"] = "daysPastDue";
  CollectionSortByOption2["TOTAL_AR"] = "totalOutstanding";
  CollectionSortByOption2["OUTSTANDING_FEES"] = "outstandingFees";
  CollectionSortByOption2["OUTSTANDING_EXPENSES"] = "outstandingExpenses";
  return CollectionSortByOption2;
})(CollectionSortByOption || {});
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["ASC"] = "asc";
  SortOrder2["DESC"] = "desc";
  return SortOrder2;
})(SortOrder || {});
var AppealStatus = /* @__PURE__ */ ((AppealStatus2) => {
  AppealStatus2["TO_BE_APPEALED"] = "TO_BE_APPEALED";
  AppealStatus2["PRE_APPEAL"] = "PRE_APPEAL";
  AppealStatus2["APPEAL_SUBMITTED"] = "APPEAL_SUBMITTED";
  AppealStatus2["APPEAL_APPROVED"] = "APPEAL_APPROVED";
  AppealStatus2["APPEAL_DENIED"] = "APPEAL_DENIED";
  AppealStatus2["NO_APPEAL"] = "NO_APPEAL";
  AppealStatus2["CLOSED"] = "CLOSED";
  AppealStatus2["DEADLINE_EXPIRED"] = "DEADLINE_EXPIRED";
  AppealStatus2["AWAITING_APPEAL_SUBMISSION"] = "AWAITING_APPEAL_SUBMISSION";
  return AppealStatus2;
})(AppealStatus || {});
var AppealType = /* @__PURE__ */ ((AppealType2) => {
  AppealType2["SUBSEQUENT"] = "SUBSEQUENT";
  AppealType2["BACKLOG"] = "BACKLOG";
  return AppealType2;
})(AppealType || {});
var APPEAL_STATUS_LABEL = {
  PRE_APPEAL: "Pre-Appeal",
  TO_BE_APPEALED: "To Be Appealed",
  APPEAL_APPROVED: "Appeal Approved",
  APPEAL_DENIED: "Appeal Denied",
  APPEAL_SUBMITTED: "Appeal Submitted",
  NO_APPEAL: "No Appeal",
  CLOSED: "Closed",
  DEADLINE_EXPIRED: "Deadline Expired",
  AWAITING_APPEAL_SUBMISSION: "Awaiting Appeal Submission",
  PARTIAL_WRITE_OFF: "Partial Write-Off"
};
var APPEAL_STATUS_COLOR = {
  TO_BE_APPEALED: "#3b82f5",
  PRE_APPEAL: "#374151",
  APPEAL_SUBMITTED: "#1E40AF",
  NO_APPEAL: "#5B21B6",
  DEADLINE_EXPIRED: "#991B1B",
  CLOSED: "#4B5563",
  APPEAL_DENIED: "#991B1B",
  APPEAL_APPROVED: "#065F46",
  AWAITING_APPEAL_SUBMISSION: "#804F00"
};
var COLLECTION_QUEUE_APPEAL_STATUSES = [
  "PRE_APPEAL" /* PRE_APPEAL */,
  "AWAITING_APPEAL_SUBMISSION" /* AWAITING_APPEAL_SUBMISSION */,
  "APPEAL_SUBMITTED" /* APPEAL_SUBMITTED */,
  "TO_BE_APPEALED" /* TO_BE_APPEALED */,
  "APPEAL_APPROVED" /* APPEAL_APPROVED */,
  "APPEAL_DENIED" /* APPEAL_DENIED */,
  "NO_APPEAL" /* NO_APPEAL */,
  "DEADLINE_EXPIRED" /* DEADLINE_EXPIRED */
];
var STATUS_CAPABILITIES = {
  ["PRE_APPEAL" /* PRE_APPEAL */]: { edit: false, rollbackTargets: [] },
  ["TO_BE_APPEALED" /* TO_BE_APPEALED */]: { edit: true, rollbackTargets: ["PRE_APPEAL" /* PRE_APPEAL */] },
  ["AWAITING_APPEAL_SUBMISSION" /* AWAITING_APPEAL_SUBMISSION */]: { edit: true, rollbackTargets: ["PRE_APPEAL" /* PRE_APPEAL */] },
  ["APPEAL_SUBMITTED" /* APPEAL_SUBMITTED */]: { edit: true, rollbackTargets: ["PRE_APPEAL" /* PRE_APPEAL */, "AWAITING_APPEAL_SUBMISSION" /* AWAITING_APPEAL_SUBMISSION */] },
  ["NO_APPEAL" /* NO_APPEAL */]: { edit: true, rollbackTargets: ["PRE_APPEAL" /* PRE_APPEAL */, "AWAITING_APPEAL_SUBMISSION" /* AWAITING_APPEAL_SUBMISSION */] },
  ["APPEAL_APPROVED" /* APPEAL_APPROVED */]: { edit: true, rollbackTargets: ["PRE_APPEAL" /* PRE_APPEAL */, "AWAITING_APPEAL_SUBMISSION" /* AWAITING_APPEAL_SUBMISSION */] },
  ["APPEAL_DENIED" /* APPEAL_DENIED */]: { edit: false, rollbackTargets: ["PRE_APPEAL" /* PRE_APPEAL */, "AWAITING_APPEAL_SUBMISSION" /* AWAITING_APPEAL_SUBMISSION */] },
  ["DEADLINE_EXPIRED" /* DEADLINE_EXPIRED */]: { edit: true, rollbackTargets: ["PRE_APPEAL" /* PRE_APPEAL */, "AWAITING_APPEAL_SUBMISSION" /* AWAITING_APPEAL_SUBMISSION */] },
  ["CLOSED" /* CLOSED */]: { edit: false, rollbackTargets: [] }
};
var EDITABLE_APPEAL_SUBMITTED_TYPES = /* @__PURE__ */ new Set([
  "SUBSEQUENT" /* SUBSEQUENT */,
  "BACKLOG" /* BACKLOG */
]);
var canEdit = (status, appealType) => {
  if (!STATUS_CAPABILITIES[status]?.edit) return false;
  if (status === "APPEAL_SUBMITTED" /* APPEAL_SUBMITTED */) {
    return appealType != null && EDITABLE_APPEAL_SUBMITTED_TYPES.has(appealType);
  }
  return true;
};
var canRollbackTo = (status, target) => (STATUS_CAPABILITIES[status]?.rollbackTargets ?? []).includes(target);
var rollbackTargetsFor = (status) => STATUS_CAPABILITIES[status]?.rollbackTargets ?? [];
var InvoiceState = /* @__PURE__ */ ((InvoiceState2) => {
  InvoiceState2["DRAFT"] = "draft";
  InvoiceState2["AWAITING_APPROVAL"] = "awaiting_approval";
  InvoiceState2["AWAITING_PAYMENT"] = "awaiting_payment";
  InvoiceState2["PAID"] = "paid";
  InvoiceState2["VOID"] = "void";
  InvoiceState2["DELETED"] = "deleted";
  return InvoiceState2;
})(InvoiceState || {});
var InvoiceKind = /* @__PURE__ */ ((InvoiceKind2) => {
  InvoiceKind2["REVENUE_KIND"] = "revenue_kind";
  InvoiceKind2["SUMMARY_KIND"] = "summary_kind";
  InvoiceKind2["TRUST_KIND"] = "trust_kind";
  InvoiceKind2["AGGREGATE_ALL"] = "aggregate_all";
  InvoiceKind2["AGGREGATE_SPLIT"] = "aggregate_split";
  InvoiceKind2["AGGREGATE_SERVICES"] = "aggregate_services";
  InvoiceKind2["AGGREGATE_EXPENSES"] = "aggregate_expenses";
  return InvoiceKind2;
})(InvoiceKind || {});
var ContactMethod = /* @__PURE__ */ ((ContactMethod2) => {
  ContactMethod2["PHONE"] = "PHONE";
  ContactMethod2["INTERNAL_EMAIL"] = "INTERNAL_EMAIL";
  ContactMethod2["EXTERNAL_EMAIL"] = "EXTERNAL_EMAIL";
  return ContactMethod2;
})(ContactMethod || {});
var PaymentOutcome = /* @__PURE__ */ ((PaymentOutcome2) => {
  PaymentOutcome2["PROMISE_TO_PAY"] = "PROMISE_TO_PAY";
  PaymentOutcome2["PAYMENT_ALREADY_ISSUED"] = "PAYMENT_ALREADY_ISSUED";
  PaymentOutcome2["PARTIAL_PAYMENT_ISSUED"] = "PARTIAL_PAYMENT_ISSUED";
  PaymentOutcome2["PAYMENT_SCHEDULED_INTERNALLY"] = "PAYMENT_SCHEDULED_INTERNALLY";
  return PaymentOutcome2;
})(PaymentOutcome || {});
var ContactAttempt = /* @__PURE__ */ ((ContactAttempt2) => {
  ContactAttempt2["SPOKE_WITH_CLIENT"] = "SPOKE_WITH_CLIENT";
  ContactAttempt2["NO_ANSWER"] = "NO_ANSWER";
  ContactAttempt2["LEFT_VOICEMAIL"] = "LEFT_VOICEMAIL";
  ContactAttempt2["EMAIL_SENT"] = "EMAIL_SENT";
  return ContactAttempt2;
})(ContactAttempt || {});
var AdministrativeFlag = /* @__PURE__ */ ((AdministrativeFlag2) => {
  AdministrativeFlag2["UPDATED_CONTACT_NEEDED"] = "UPDATED_CONTACT_NEEDED";
  AdministrativeFlag2["CLIENT_REQUESTED_CALLBACK"] = "CLIENT_REQUESTED_CALLBACK";
  AdministrativeFlag2["ESCALATED_TO_ATTORNEY"] = "ESCALATED_TO_ATTORNEY";
  AdministrativeFlag2["ESCALATED_TO_LEADERSHIP"] = "ESCALATED_TO_LEADERSHIP";
  return AdministrativeFlag2;
})(AdministrativeFlag || {});
var ADMINISTRATIVE_FLAG_LABEL = {
  ["UPDATED_CONTACT_NEEDED" /* UPDATED_CONTACT_NEEDED */]: "Updated Contact Needed",
  ["CLIENT_REQUESTED_CALLBACK" /* CLIENT_REQUESTED_CALLBACK */]: "Client Requested Callback",
  ["ESCALATED_TO_ATTORNEY" /* ESCALATED_TO_ATTORNEY */]: "Escalated to Attorney",
  ["ESCALATED_TO_LEADERSHIP" /* ESCALATED_TO_LEADERSHIP */]: "Escalated to Leadership"
};
var ESCALATED_ADMINISTRATIVE_FLAGS = /* @__PURE__ */ new Set([
  "ESCALATED_TO_ATTORNEY" /* ESCALATED_TO_ATTORNEY */,
  "ESCALATED_TO_LEADERSHIP" /* ESCALATED_TO_LEADERSHIP */
]);
var WriteOffStatus = /* @__PURE__ */ ((WriteOffStatus2) => {
  WriteOffStatus2["PENDING"] = "PENDING";
  WriteOffStatus2["ESCALATED"] = "ESCALATED";
  WriteOffStatus2["APPROVED"] = "APPROVED";
  WriteOffStatus2["REJECTED"] = "REJECTED";
  WriteOffStatus2["ARCHIVED"] = "ARCHIVED";
  WriteOffStatus2["CLOSED"] = "CLOSED";
  return WriteOffStatus2;
})(WriteOffStatus || {});
var ACCEPTED_WRITE_OFF_STATUSES = ["APPROVED" /* APPROVED */, "ARCHIVED" /* ARCHIVED */];
var WriteOffCategory = /* @__PURE__ */ ((WriteOffCategory2) => {
  WriteOffCategory2["WRITE_OFF"] = "WRITE_OFF";
  WriteOffCategory2["BAD_DEBT"] = "BAD_DEBT";
  return WriteOffCategory2;
})(WriteOffCategory || {});
var WriteOffType = /* @__PURE__ */ ((WriteOffType2) => {
  WriteOffType2["PROMPT_PAYMENT"] = "PROMPT_PAYMENT";
  WriteOffType2["BULK_DISCOUNT"] = "BULK_DISCOUNT";
  WriteOffType2["ADMIN_FEE"] = "ADMIN_FEE";
  WriteOffType2["CLIENT_REFUSED"] = "CLIENT_REFUSED";
  WriteOffType2["AUTO_PROPOSED"] = "AUTO_PROPOSED";
  WriteOffType2["CUTS_APPLIED"] = "CUTS_APPLIED";
  return WriteOffType2;
})(WriteOffType || {});
var EDIT_MUTATED_WRITE_OFF_TYPES = /* @__PURE__ */ new Set([
  "CUTS_APPLIED" /* CUTS_APPLIED */,
  "PROMPT_PAYMENT" /* PROMPT_PAYMENT */,
  "BULK_DISCOUNT" /* BULK_DISCOUNT */,
  "ADMIN_FEE" /* ADMIN_FEE */
]);
var areWriteOffOriginsKnown = (writeOffs) => (writeOffs ?? []).filter((w) => w.type != null && EDIT_MUTATED_WRITE_OFF_TYPES.has(w.type)).every((w) => w.fromAppealStatus != null);
var EDIT_INELIGIBLE_MESSAGE = "This invoice can't be edited safely \u2014 it's missing data the edit relies on, so saving could change the wrong amounts. Contact your administrator to get it updated.";
var ROLLBACK_TO_AWAITING_INELIGIBLE_MESSAGE = "Some of this appeal's earlier details can't be safely restored. Roll back to Pre-Appeal instead, then re-enter the appeal.";
var ROLLBACK_AAS_BACKLOG_MESSAGE = "Backlog appeals were never awaiting submission, so they can only go back to Pre-Appeal.";
var ROLLBACK_PRE_REAPPEAL_MESSAGE = "This appeal continues an earlier one that already collected payment, so it can't be rolled all the way back to Pre-Appeal. Roll back to Awaiting Appeal Submission instead.";
var ROLLBACK_PRE_REAPPEAL_NO_TARGET_MESSAGE = "This appeal was re-started from To Be Appealed, so rolling it back to Pre-Appeal isn't supported.";
var ROLLBACK_PRE_REAPPEAL_SHORT = "Already collected payment \u2014 Pre-Appeal unavailable.";
var ROLLBACK_AAS_NO_TIMEKEEPERS_MESSAGE = "This appeal has no timekeepers, so it can't return to Awaiting Appeal Submission. Roll back to Pre-Appeal instead.";
var EmailQueueStatus = /* @__PURE__ */ ((EmailQueueStatus2) => {
  EmailQueueStatus2["QUEUED"] = "QUEUED";
  EmailQueueStatus2["CLOSED"] = "CLOSED";
  return EmailQueueStatus2;
})(EmailQueueStatus || {});
var ArClientType = /* @__PURE__ */ ((ArClientType2) => {
  ArClientType2["PRIVATE"] = "Private";
  ArClientType2["INSURANCE"] = "Insurance";
  return ArClientType2;
})(ArClientType || {});
var CLIENT_TYPE_FILTER_ALL = "All";
var ArLedgerReportType = /* @__PURE__ */ ((ArLedgerReportType2) => {
  ArLedgerReportType2["CLIENT"] = "client";
  ArLedgerReportType2["MATTER"] = "matter";
  ArLedgerReportType2["RESPONSIBLE_ATTORNEY"] = "responsible";
  ArLedgerReportType2["ORIGINATING_ATTORNEY"] = "originating";
  return ArLedgerReportType2;
})(ArLedgerReportType || {});
var ArEmailGroupByOption = /* @__PURE__ */ ((ArEmailGroupByOption2) => {
  ArEmailGroupByOption2["CLIENT"] = "client";
  ArEmailGroupByOption2["ORIGINATING"] = "originating";
  ArEmailGroupByOption2["RESPONSIBLE"] = "responsible";
  ArEmailGroupByOption2["NONE"] = "none";
  return ArEmailGroupByOption2;
})(ArEmailGroupByOption || {});
var EmailSortByOption = /* @__PURE__ */ ((EmailSortByOption2) => {
  EmailSortByOption2["AMOUNT_OUTSTANDING"] = "amountOutstanding";
  EmailSortByOption2["MAX_DAYS_PAST_DUE"] = "maxDaysPastDue";
  return EmailSortByOption2;
})(EmailSortByOption || {});
var ArEmailAgingBucket = /* @__PURE__ */ ((ArEmailAgingBucket2) => {
  ArEmailAgingBucket2["ALL"] = "all";
  ArEmailAgingBucket2["CURRENT"] = "current";
  ArEmailAgingBucket2["DAYS_31_40"] = "31_40";
  ArEmailAgingBucket2["DAYS_41_50"] = "41_50";
  ArEmailAgingBucket2["DAYS_51_60"] = "51_60";
  ArEmailAgingBucket2["DAYS_61_PLUS"] = "61_plus";
  ArEmailAgingBucket2["DAYS_45_54"] = "45_54";
  ArEmailAgingBucket2["DAYS_55_64"] = "55_64";
  ArEmailAgingBucket2["DAYS_65_74"] = "65_74";
  ArEmailAgingBucket2["DAYS_75_PLUS"] = "75_plus";
  return ArEmailAgingBucket2;
})(ArEmailAgingBucket || {});
var AppealSortByOption = /* @__PURE__ */ ((AppealSortByOption2) => {
  AppealSortByOption2["AMOUNT_PAID"] = "amountPaid";
  AppealSortByOption2["AMOUNT_DUE"] = "amountDue";
  AppealSortByOption2["TOTAL_AMOUNT"] = "totalAmount";
  AppealSortByOption2["MAX_DAYS_PAST_DUE"] = "maxDaysPastDue";
  AppealSortByOption2["DEADLINES"] = "deadline";
  return AppealSortByOption2;
})(AppealSortByOption || {});
var WriteOffSortByOption = /* @__PURE__ */ ((WriteOffSortByOption2) => {
  WriteOffSortByOption2["AMOUNT_PAID"] = "amountPaid";
  WriteOffSortByOption2["AMOUNT_DUE"] = "outstandingBalance";
  WriteOffSortByOption2["WRITE_OFF_AMOUNT"] = "writeOffAmount";
  WriteOffSortByOption2["TOTAL_AMOUNT"] = "total";
  WriteOffSortByOption2["DAYS_PAST_DUE"] = "daysPastDue";
  return WriteOffSortByOption2;
})(WriteOffSortByOption || {});
var CategoryTypes = /* @__PURE__ */ ((CategoryTypes2) => {
  CategoryTypes2["CLIENT"] = "client";
  CategoryTypes2["MATTER"] = "matter";
  CategoryTypes2["ORIGINATING"] = "originating";
  CategoryTypes2["RESPONSIBLE"] = "responsible";
  return CategoryTypes2;
})(CategoryTypes || {});
var AttorneyResponseAction = /* @__PURE__ */ ((AttorneyResponseAction2) => {
  AttorneyResponseAction2["APPEAL"] = "APPEAL";
  AttorneyResponseAction2["NO_APPEAL"] = "NO_APPEAL";
  return AttorneyResponseAction2;
})(AttorneyResponseAction || {});
var AttorneyResponseStatus = /* @__PURE__ */ ((AttorneyResponseStatus2) => {
  AttorneyResponseStatus2["SUBMITTED"] = "SUBMITTED";
  AttorneyResponseStatus2["EDIT_REQUESTED"] = "EDIT_REQUESTED";
  AttorneyResponseStatus2["EDIT_APPROVED"] = "EDIT_APPROVED";
  return AttorneyResponseStatus2;
})(AttorneyResponseStatus || {});
var DeadlineTier = /* @__PURE__ */ ((DeadlineTier2) => {
  DeadlineTier2["TIER_1"] = "tier1";
  DeadlineTier2["TIER_2"] = "tier2";
  DeadlineTier2["TIER_3"] = "tier3";
  return DeadlineTier2;
})(DeadlineTier || {});
var ReportExportFormat = /* @__PURE__ */ ((ReportExportFormat2) => {
  ReportExportFormat2["EXCEL"] = "xlsx";
  ReportExportFormat2["PDF"] = "pdf";
  ReportExportFormat2["CSV"] = "csv";
  return ReportExportFormat2;
})(ReportExportFormat || {});

// src/permission.ts
var Platform = /* @__PURE__ */ ((Platform2) => {
  Platform2["LYDECKER"] = "Lydecker";
  Platform2["XTND"] = "XTND";
  return Platform2;
})(Platform || {});
var Action = /* @__PURE__ */ ((Action2) => {
  Action2["MANAGE"] = "manage";
  Action2["CREATE"] = "create";
  Action2["READ"] = "read";
  Action2["UPDATE"] = "update";
  Action2["DELETE"] = "delete";
  return Action2;
})(Action || {});

// src/activity-log.ts
var ActivityEventType = /* @__PURE__ */ ((ActivityEventType2) => {
  ActivityEventType2["CREATED"] = "created";
  ActivityEventType2["UPDATED"] = "updated";
  ActivityEventType2["DELETED"] = "deleted";
  ActivityEventType2["ROLLED_BACK"] = "rolled_back";
  return ActivityEventType2;
})(ActivityEventType || {});
var ActivityCategory = /* @__PURE__ */ ((ActivityCategory2) => {
  ActivityCategory2["INVOICE"] = "invoice";
  ActivityCategory2["WRITE_OFF"] = "write-off";
  return ActivityCategory2;
})(ActivityCategory || {});
export {
  ACCEPTED_WRITE_OFF_STATUSES,
  ADMINISTRATIVE_FLAG_LABEL,
  APPEAL_STATUS_COLOR,
  APPEAL_STATUS_LABEL,
  Action,
  ActivityCategory,
  ActivityEventType,
  AdministrativeFlag,
  AppealSortByOption,
  AppealStatus,
  AppealType,
  ArClientType,
  ArEmailAgingBucket,
  ArEmailGroupByOption,
  ArExceptionFlag,
  ArLedgerReportType,
  AttorneyResponseAction,
  AttorneyResponseStatus,
  CLIENT_TYPE_FILTER_ALL,
  COLLECTION_QUEUE_APPEAL_STATUSES,
  CategoryTypes,
  CollectionSortByOption,
  ConfidenceLevel,
  ContactAttempt,
  ContactMethod,
  DeadlineTier,
  DocumentCategory,
  EDITABLE_APPEAL_SUBMITTED_TYPES,
  EDIT_INELIGIBLE_MESSAGE,
  EDIT_MUTATED_WRITE_OFF_TYPES,
  ESCALATED_ADMINISTRATIVE_FLAGS,
  EmailQueueStatus,
  EmailSortByOption,
  ExportType,
  GroupByOption,
  InvoiceKind,
  InvoiceState,
  InvoiceStatus,
  LoginProvider,
  MatterReportType,
  MatterTransactionType,
  PaymentOutcome,
  Platform,
  ROLLBACK_AAS_BACKLOG_MESSAGE,
  ROLLBACK_AAS_NO_TIMEKEEPERS_MESSAGE,
  ROLLBACK_PRE_REAPPEAL_MESSAGE,
  ROLLBACK_PRE_REAPPEAL_NO_TARGET_MESSAGE,
  ROLLBACK_PRE_REAPPEAL_SHORT,
  ROLLBACK_TO_AWAITING_INELIGIBLE_MESSAGE,
  ReconciliationStatus,
  ReportExportFormat,
  STATUS_CAPABILITIES,
  SortOrder,
  Status,
  TrustReconciliationFlag,
  UserRole,
  UserStatus,
  WriteOffCategory,
  WriteOffSortByOption,
  WriteOffStatus,
  WriteOffType,
  areWriteOffOriginsKnown,
  canEdit,
  canRollbackTo,
  rollbackTargetsFor
};
//# sourceMappingURL=index.js.map